export default __webpack_public_path__ + "static/6-6d8311fc48016930bdcdc11198541876.png";